// Späte Bindung der PA-Singletons — bricht die Import-Zyklen classes → singletons.
// Diese Datei importiert zur Laufzeit NICHTS (nur Typ-Importe, die beim Kompilieren gelöscht
// werden): Klassen greifen über PARegistry.x zu, die Singleton-Module registrieren beim Laden
// eine Lazy-Factory (Lazy-Init-Verhalten von .Instance bleibt dadurch unverändert).
// Bonus: In Unit-Tests lassen sich Singletons über register() durch Stubs ersetzen.
import type { PADataControl } from "./pa-data-control";
import type { PAFilterControl } from "./pa-filter-control";
import type { PASettingsControl } from "./pa-settings-control";
import type { PATimeControl } from "./pa-time-control";
import type { PATourPlannerControl } from "./pa-tourplanner-control";

type PARegistryKey = 'dataControl' | 'timeControl' | 'filterControl' | 'settingsControl' | 'tourPlannerControl';

export class PARegistry {

  private static factories = new Map<PARegistryKey, () => unknown>();

  static register(key: PARegistryKey, factory: () => unknown): void {
    this.factories.set(key, factory);
  }

  private static resolve<T>(key: PARegistryKey): T {
    const factory = this.factories.get(key);
    if (!factory) {
      // Darf nur passieren, wenn das Singleton-Modul noch nie geladen wurde — dann fehlt am
      // Einstiegspunkt ein Seiteneffekt-Import von pa-singleton-bootstrap.ts
      throw new Error(`PARegistry: '${key}' ist nicht registriert — pa-singleton-bootstrap am Einstiegspunkt importieren`);
    }
    return factory() as T;
  }

  static get dataControl(): PADataControl {
    return this.resolve<PADataControl>('dataControl');
  }

  static get timeControl(): PATimeControl {
    return this.resolve<PATimeControl>('timeControl');
  }

  static get filterControl(): PAFilterControl {
    return this.resolve<PAFilterControl>('filterControl');
  }

  static get settingsControl(): PASettingsControl {
    return this.resolve<PASettingsControl>('settingsControl');
  }

  static get tourPlannerControl(): PATourPlannerControl {
    return this.resolve<PATourPlannerControl>('tourPlannerControl');
  }
}
